import { render, staticRenderFns } from "./PlanningStatus.vue?vue&type=template&id=641fbb84&scoped=true"
import script from "./PlanningStatus.vue?vue&type=script&lang=js"
export * from "./PlanningStatus.vue?vue&type=script&lang=js"
import style0 from "./PlanningStatus.vue?vue&type=style&index=0&id=641fbb84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641fbb84",
  null
  
)

export default component.exports